import { useMemo, useState } from 'react';
import { NumberField, SelectField, SliderField, ResultPanel, ResultItem, ResultNote } from './fields';
import { useAnimatedNumber } from './AnimatedNumber';
import { PAIRS } from './pairs';

export const POSITION_ACCENT = '#7C3AED';

export default function PositionSizeCalculator() {
  const [balance, setBalance] = useState(10000);
  const [risk, setRisk] = useState(2);
  const [stopLoss, setStopLoss] = useState(30);
  const [pair, setPair] = useState('EURUSD');

  const pairMeta = useMemo(() => PAIRS.find((p) => p.value === pair) ?? PAIRS[0], [pair]);

  const riskAmount = (balance * risk) / 100;
  const lotSize = stopLoss > 0 ? riskAmount / (stopLoss * pairMeta.pipValue) : 0;

  const animatedRisk = useAnimatedNumber(riskAmount);
  const animatedLot = useAnimatedNumber(lotSize);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <NumberField
          label="Vốn tài khoản"
          value={balance}
          onChange={setBalance}
          suffix="$"
          min={0}
          step={100}
          accent={POSITION_ACCENT}
        />
        <SliderField
          label="Tỷ lệ rủi ro mỗi lệnh"
          value={risk}
          onChange={setRisk}
          min={0.5}
          max={5}
          step={0.5}
          display={`${risk}%`}
          accent={POSITION_ACCENT}
        />
        <NumberField
          label="Khoảng cách cắt lỗ"
          value={stopLoss}
          onChange={setStopLoss}
          suffix="pips"
          min={0}
          step={5}
          accent={POSITION_ACCENT}
        />
        <SelectField
          label="Cặp tiền tệ"
          value={pair}
          onChange={setPair}
          options={PAIRS.map((p) => ({ value: p.value, label: p.label }))}
          accent={POSITION_ACCENT}
        />
      </div>

      <div className="mt-6">
        <ResultPanel accent={POSITION_ACCENT}>
          <ResultItem label="Số tiền rủi ro" value={`$${animatedRisk.toFixed(2)}`} accent={POSITION_ACCENT} big />
          <ResultItem
            label="Khối lượng lệnh đề xuất"
            value={`${animatedLot.toFixed(2)} lot`}
            accent={POSITION_ACCENT}
            big
          />
          <ResultNote>
            Giá trị 1 pip ≈ ${pairMeta.pipValue.toFixed(2)} / lot · {pairMeta.label}
          </ResultNote>
        </ResultPanel>
      </div>
    </>
  );
}